<template>
  <i></i>
</template>

<script>
export default {
  name: 'message-push-native',
  props: {
    URI: {
      // 连接着服务端的WebSocket的代理的地址  类似于服务器的ip地址
      type: String
    },
    port: {
      type: String
    },
    // 带协议的连接地址，传入这个属性会覆盖上面的两个属性
    URL: String,
    token: {
      type: String,
      required: true
    },
    username: {
      type: String,
      required: true
    },
    componentSet: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      client: null,
      // 是否是js触发的关闭，如果不是的话，会触发断线重连机制
      isManul: false,
      seq: 1,
      timeout: 10
    }
  },
  beforeDestroy () {
    this.destroy()
  },
  mounted () {
    this.init()
  },
  methods: {
    // 初始化链接
    init () {
      if (window.WebSocket) {
        let url = `ws://${this.URI}:${this.port}`
        if (this.URL !== '') url = this.URL
        this.client = new WebSocket(url)

        this.client.onopen = this.onOpen
        this.client.onmessage = this.onMessage
        this.client.onerror = this.onError
        this.client.onclose = this.onClose
      } else {
        this.$message({
          message: `你的浏览器版本太低了,不支持Websocket,会导致你接收不到实时数据!'
                  您可以更换一个支持websocket浏览器，如：IE11 或者 Chrome！`,
          type: 'warning'
        })
      }
    },
    // 当ws建立连接的时候的处理函数，需要向mps发送开始接收推送消息的命令
    onOpen () {
      let _message = {
        Type: 1,
        Seq: this.seq,
        Version: 1,
        Client: {
          agent: 'bs',
          user: this.username,
          way: 'websocket',
          componentSet: this.componentSet
        },
        Security: {
          token: this.token
        }
      }
      this.send(_message)
    },
    // 当接受到消息的处理函数
    onMessage (event) {
      let _data = JSON.parse(event.data)
      // 当接收到推送的消息时，向外层派发接受函数，并向mps发送确认收到消息
      if (_data.Type === 3) {
        let _message = {
          Code: 200,
          Describe: 'OK',
          Type: 3,
          Seq: _data.Seq,
          Version: 1
        }
        // 向mps发送确认收到消息
        this.send(_message)
        // let _topic = _data.Message.EventData.ext.data.topicName
        let _res = _data.Message.EventData.ext
        // 如果是字符串的推送结果，看是否能转为json格式，如果可以的话，向外层派发json格式数据，如果不能派发原有的字符串
        if (typeof _res === 'string') {
          try {
            _res = JSON.parse(_res)
          } catch (error) {
            _res = _data.Message.EventData.ext.data
          }
        }
        // 向外层派发消息
        this.$emit('message-get', _res)
      }
    },
    reconnect () {
      // 每次请求链接时候的序列号需要加1，放在这边加1的原因是关闭链接的时候，需要用到原先链接的序列号
      this.seq++
      this.init()
    },
    // 当ws出错的处理函数
    onError () {
      // 出错的时候重连
      if (this.timeout > 0) {
        this.reconnect()
        this.timeout--
      } else {
        this.destroy()
      }
    },
    // 当ws关闭的处理函数
    onClose () {
      // 当关闭时，又不是手动触发的，重连
      if (!this.isManul) {
        this.reconnect()
      }
    },
    // 销毁链接
    destroy () {
      this.isManul = true
      let _message = {
        Type: 2,
        Seq: this.seq,
        Version: 1,
        Client: {
          agent: 'bs',
          user: this.username,
          way: 'websocket',
          componentSet: this.componentSet
        },
        Security: {
          token: this.token
        }
      }
      this.send(_message)
      this.client.close()
    },
    // 向mps发送消息
    send (message) {
      if (typeof message === 'string') {
        this.client.send(message)
      } else {
        this.client.send(JSON.stringify(message))
      }
    }
  }
}
</script>
